import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from 'shards-react';
import { formatNumberAmount } from '../../../utils/general';
import { setDateForTable, setInputDate } from '../../../utils/date';
import { get_currency_list } from '../../../redux/actions/subscriber/invoice';
import ReactTable from 'react-table';
import classNames from 'classnames';
import Multiselect from 'multiselect-react-dropdown';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { bulk_update_automation_status, download_automation_results, get_automation_bulk_action_list, get_automation_process_details, reset_automation_detail, reset_process_flag } from '../../../redux/actions/subscriber/automation';
import { GeneralSettingsKeys, NavgationPageLocationKey } from '../../../utils/constants';
import ConfirmAlert from '../../../components/common/ConfirmAlert';

const STATUS_ALL = 'All Statuses';
const ALL = 'All';
const CHANGE_STATUS = 'CHANGE_STATUS';
const DOWNLOAD = 'DOWNLOAD';
const AutomationResultDetail = ({
    currencyList, get_currency_list, bulkUpdate,
    get_automation_process_details, automationResultData,
    reset_automation_detail, reset_process_flag,
    automationActions, get_automation_bulk_action_list,
    bulk_update_automation_status, download_automation_results
}) => {
    const [initialState, setInitialState] = useState({
        refNum: 0,
        process: '',
        invoiceDate: '',
        dateActioned: '',
        dueDate: '',
        resultStatus: '',
        currency: '',

        totalInvoiceAmount: 0,
        totalPayableAmount: 0,
        totalPaymentIn: 0,
        totalPaymentOut: 0,

        autoRefNum: "",
        description: "",
        type: '',
        payperiod: '',
        status: '',
        currency: '',
        from: '',
        to: '',
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        bulkAction: '',
    })

    const [formData, setFormData] = useState(initialState)
    const [tablePayScheduleData, setTablePayScheduleData] = useState([]);
    const [tableCurrencyData, setTableCurrencyData] = useState([]);
    const [tableItemData, setTableItemData] = useState([]);

    const defaultStatus = [];
    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
    const [selectedStatusValues, setSelectedStatusValues] = useState([...defaultStatus]);

    const defaultPayPeriod = [];
    const [payPeriodDropdownOptions, setPayPeriodDropdownOptions] = useState([]);
    const [selectedPayPeriodValues, setSelectedPayPeriodValues] = useState([...defaultPayPeriod]);

    const defaultType = [];
    const [typeDropdownOptions, setTypeDropdownOptions] = useState([]);
    const [selectedTypeValues, setSelectedTypeValues] = useState([...defaultType]);

    const defaultCurrency = [];
    const [currencyDropdownOptions, setCurrencyDropdownOptions] = useState([]);
    const [selectedCurrencyValues, setSelectedCurrencyValues] = useState([...defaultCurrency]);

    const [openModal, setOpenModal] = useState(false);
    const location = useLocation();
    const [stateId, setStateId] = useState(0);
    const history = useHistory();

    const sessionUser = JSON.parse(localStorage.getItem("user"));
    const fxRateFormat = sessionUser[GeneralSettingsKeys.defaultKeyViewIntermediateCalculation] !== undefined ? 
                        sessionUser[GeneralSettingsKeys.defaultKeyViewIntermediateCalculation] : "2";

    const sampleStatus = ["Created", "Issued", "Cancelled", "Partial Paid", "Paid", "Funded", "Partially Funded", "Received", "Sent", "Partial"]
    const generalStatus = ["Created", "Issued", "Cancelled"]
    const verifyCretedStatus = generalStatus[0]; 
    const invoicePayableStatus = ["Partial Paid", "Paid"]
    const payableStatus = ["Funded", "Partially Funded"]
    const paymentStatus = ["Received", "Sent", "Partial"]

    const generalStatusGroup = generalStatus.map(status => <option key={status} value={status}>{status}</option>);

    const invoicePayableStatusGroup = <optgroup label="---- Invoice, Payable Specific ----"> {
        invoicePayableStatus.map(status => <option key={status} value={status}>{status}</option>)} </optgroup>;

    const payableStatusGroup = <optgroup label="---- Payable Specific ----"> {
        payableStatus.map(status => <option key={status} value={status}>{status}</option>)} </optgroup>;
    
    const paymentStatusGroup = <optgroup label="---- Payment Specific ----"> {
        paymentStatus.map(status => <option key={status} value={status}>{status}</option>)} </optgroup>;

    const invoiceSetStatusListOptions = sampleStatus.map((status, i) => <option key={status + i} value={status}>{status}</option>)
    const typeValues = ["Invoice", "Payable", "Payment"];

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });
    

    function navigationLinkSetup(e, refId, type){
        e.preventDefault(); 
        switch (type) {
            case 'Invoice':
                history.push({
                    pathname: `/new-invoice`,
                    state: { refNum: refId }
                });
                break;
            case 'Payable':
                history.push({
                    pathname: `/payable`,
                    state: { refNum: refId }
                });
                break;
            default:
                history.push({
                    pathname: `/new-payment`,
                    state: { refNum: refId }
                });
                break;
        }
        return false;
    }

    function onContextMenuLinkSetup(e, refId, type){
        if(e.type === 'contextmenu'){
            switch (type) {
                case 'Invoice':
                    localStorage.setItem(NavgationPageLocationKey.InvoiceCurrentAddEdit, refId);
                    break;
                case 'Payable':
                    localStorage.setItem(NavgationPageLocationKey.PayableCurrentAddEdit, refId);
                    break;
                default:
                    localStorage.setItem(NavgationPageLocationKey.PaymentCurrentAddEdit, refId);
                    break;
            }
        }
    }

    function openLinkInNewTab(e, refId, type) {
        e.preventDefault();
        switch (type) {
            case 'Invoice':
                localStorage.setItem(NavgationPageLocationKey.InvoiceCurrentAddEdit, refId);
                window.open('/new-invoice', '_blank');
                break;
            case 'Payable':
                localStorage.setItem(NavgationPageLocationKey.PayableCurrentAddEdit, refId);
                window.open('/payable', '_blank');
                break;
            default:
                localStorage.setItem(NavgationPageLocationKey.PaymentCurrentAddEdit, refId);
                window.open('/new-payment', '_blank');
                break;
        }
    }

    const setRefNumPrefixs = (ref, type) => {
        if (ref === undefined || ref === null || ref === '' && type === "" || type === undefined)
            return false;

        let retString = '';
        let retURL = '';

        switch (type) {
            case 'Invoice':
                retString = "INV-" + ref
                retURL = "/new-invoice";
                break;
            case 'Payable':
                retString = "PAY-" + ref
                retURL = "/payable";
                break;
            default:
                retString = "PMT-" + ref
                retURL = "/new-payment";
                break;
        }
        return (
            <a href={retURL} onClick={(e) => { openLinkInNewTab(e, ref, type) }}
                onContextMenu={(e) => onContextMenuLinkSetup(e, ref, type)}>
                {retString}
            </a>
        )
    }

    const onCheck = (refNum) => {
        let checkedTableData = tableItemData.map(data => {
            if (data.refNum === refNum) {
                data.checked = !data.checked
            }
            return data;
        })

        setTableItemData(checkedTableData);
    }

    const checkAll = (e) => {

        let checkedTableData = tableItemData.map(data => {
            data.checked = e.target.checked;
            return data;
        })
        setTableItemData(checkedTableData);
    }

    const isAllChecked = () => {
        if (tableItemData.length === 0) return false

        for (let data of tableItemData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }

    const tablePayScheduleColumns = [
        {
            Header: "Pay Schedule",
            accessor: "paySchedule",
            minWidth: 150,
        },
        {
            Header: "Pay Period",
            accessor: "payPeriod",
            minWidth: 110,
        }
    ];

    const tableCurrencyColumns = [
        {
            Header: "Currency",
            accessor: "currency",
            minWidth: 100,
        },
        {
            Header: "FX Rate",
            accessor: "fxRate",
            minWidth: 80,
            Cell: row => <span className="w-100">{formatNumberAmount(row.original.fxRate, 'en-US', fxRateFormat)}</span>
        }
    ]

    const tableColumns = [
        {
            //Added on change for console errors
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} onChange={() => { }} />,
            accessor: "action",
            maxWidth: 30,
            minWidth: 30,
            sortable: false,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum}
                value={row.original.refNum} onChange={() => { }}
                onClick={() => onCheck(row.original.refNum)} />
        },
        {
            Header: "Ref #",
            accessor: "refNum",
            minWidth: 70,
            //Cell: row => <span className="w-100">{setRefNumPrefixs(row.original.refNum, row.original.type)}</span>
            Cell: row => setRefNumPrefixs(row.original.refNum, row.original.type)
        },
        {
            Header: "Type",
            accessor: "type",
            minWidth: 70,
        },
        {
            Header: "Date",
            accessor: "date",
            minWidth: 80,
            Cell: row => setDateForTable(row.original.date)
        },
        {
            Header: "Description",
            accessor: "description",
            minWidth: 180,
            Cell: row => <span className="w-100 text-left" title={row.original.description}>{ row.original.description }</span>
        },
        {
            Header: "Pay Period",
            accessor: "payperiod",
            minWidth: 100,
            Cell: row => <span className="w-100" title={row.original.payperiod}>{ row.original.payperiod }</span>
        },
        {
            Header: "Status",
            accessor: "status",
            minWidth: 80,
        },
        {
            Header: "Currency",
            accessor: "currency",
            minWidth: 60,
        },
        {
            Header: "Amount",
            accessor: "amount",
            minWidth: 110,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.amount, 'en-US', 2, 2)}</span>
        },
    ]

    const reset = () => {
        setFormData({ ...initialState });
        setSelectedCurrencyValues([]);
        setSelectedPayPeriodValues([]);
        setSelectedStatusValues([]);
        setSelectedTypeValues([]);
        
        //Need to change the objcect name
        get_automation_process_details(stateId, "", "", "", "", "", "", "", "")
    }

    const onSearch = (e) => {
        e.preventDefault()
        let splitedRef = formData.autoRefNum.split('-');
        const searchRefNum  = splitedRef.length > 1 ? splitedRef[1] : formData.autoRefNum;
        const selectedTypes = selectedTypeValues.map(status => status.key).toLocaleString();
        const selectedPayPeriod = selectedPayPeriodValues.map(status => status.key).toLocaleString();
        const selectedCurrency = selectedCurrencyValues.map(status => status.key).toLocaleString();
        const selectedStatus = selectedStatusValues.map(status => status.key).toLocaleString();
        get_automation_process_details(stateId, searchRefNum
            , formData.description, selectedTypes
            , selectedPayPeriod, selectedStatus
            , selectedCurrency, setInputDate(formData.from), setInputDate(formData.to) )
    }

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        let list = currencyList.map(data => ({
            cat: data,
            key: data
        }))

        setCurrencyDropdownOptions([{
            cat: 'All',
            key: 'All'
        }, ...list])
    }, [currencyList])

    useEffect(() => {
        if (Object.keys(automationResultData).length > 0) {
            setTableItemData([...automationResultData.itemList ?? []])
            setTablePayScheduleData([...automationResultData.payperiodList ?? []])
            setTableCurrencyData([...automationResultData.currencyList ?? []])

            //Prepare main details
            setFormData({
                ...formData,
                refNum: automationResultData?.refNum,
                process: automationResultData?.process,
                actionedBy: automationResultData?.actionedBy,
                dateActioned: automationResultData?.dateActioned,
                dueDate: automationResultData?.dueDate,
                invoiceDate: automationResultData?.invoiceDate,
                resultStatus: automationResultData?.resultStatus,
                currency: automationResultData?.currencyList?.[0]?.currency,

                totalInvoiceAmount: automationResultData?.totalInvoiceAmount,
                totalPayableAmount: automationResultData?.totalPayableAmount,
                totalPaymentIn: automationResultData?.totalPaymentIn,
                totalPaymentOut: automationResultData?.totalPaymentOut,
            })

            let payPeriodOptions = automationResultData?.payperiodList?.map(status => ({
                cat: status.payPeriod,
                key: status.payPeriod
            }))

            setPayPeriodDropdownOptions([{
                cat: '',
                key: ALL
            }, ...payPeriodOptions])
        }
    }, [automationResultData]);

    const setTypeOptions = () => {
        let typeOptions = typeValues.map(status => ({
            cat: status,
            key: status
        }))

        setTypeDropdownOptions([{
            cat: '',
            key: ALL
        }, ...typeOptions])
    }

    const setStatusOptions = () => {
        let statusOptions = sampleStatus.map(status => ({
            cat: status,
            key: status
        }))

        setStatusDropdownOptions([{
            cat: '',
            key: STATUS_ALL
        }, ...statusOptions])
    }

    useEffect(() => {
        if (stateId === 0) {
            if (location.state !== undefined && location.state !== null) {
                //Take from state
                setStateId(location.state?.refNum);
                get_automation_process_details(location.state?.refNum, '', '', '', '', '', '', '', '')
            }
            else if (localStorage.getItem(NavgationPageLocationKey.AutomationLogAddEdit) !== null) {
                //Take from local storage 
                setStateId(localStorage.getItem(NavgationPageLocationKey.AutomationLogAddEdit));
                get_automation_process_details(localStorage.getItem(NavgationPageLocationKey.AutomationLogAddEdit), '', '', '', '', '', '', '', '')
                const newState = { refNum: localStorage.getItem(NavgationPageLocationKey.AutomationLogAddEdit) };
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.AutomationLogAddEdit);
            }
        }
        get_currency_list();
        setTypeOptions();
        setStatusOptions();
        //get_automation_bulk_action_list();
        return reset_automation_detail;
        
    }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (e.nativeEvent.submitter.name === 'set') {
            
            let refList = tableItemData.filter(data => data.checked).map(mapData => { 
                return { 
                    refNum: mapData.refNum,
                    type: mapData.type
                } 
            })

            const updated = await bulk_update_automation_status({ automationLogRefNum: stateId, itemList: [...refList], status: formData.status });
            if (updated) {
                get_automation_process_details(stateId, '', '', '', '', '', '', '', '')
                toggle();
            }
        }
        else {
            //set_bulk_update();
            toggle();
        }
    }

    const toggle = () => {
        setOpenModal(!openModal);
        setFormData({ ...formData, bulkAction: '' });
    }

    const resetProcessFlag = async () => {
        //Check the non created status
        let itemList = tableItemData.filter(data => data.status !== verifyCretedStatus).map(mapData => { 
            return ((mapData.type === "Invoice" ? "INV-" : mapData.type === "Payable" ? "PAY-" : "PMT-") + mapData.refNum)
        })

        if(itemList.length > 0){
            setConfirmAlert({
                ...confirmAlert,
                confirmMsg: 'Are you sure, you want to cancel ' + itemList.join(", ") + '?',
                visible: true,
                onConfirm: async () => {
                    let ret = await reset_process_flag(stateId, true)
                    if(ret)
                        history.push(`/automation-logs`);
                }
            })
        }
        else {
            //Navigate to listing screeen
            let ret = await reset_process_flag(stateId, false)
            if(ret)
                history.push(`/automation-logs`);
        }
    }

    useEffect(() => {
        if(formData.bulkAction !== ""){
            //check if there is any record is selected

            setOpenModal(formData.bulkAction === CHANGE_STATUS)
            if(formData.bulkAction === DOWNLOAD){
                //call an download API
                let refList = tableItemData.filter(data => data.checked).map(mapData => { 
                    return { 
                        refNum: mapData.refNum,
                        type: mapData.type
                    } 
                })
                download_automation_results({ automationLogRefNum: stateId, itemList: [...refList] });
            }
        }
    }, [formData.bulkAction])


    return (

        <Container fluid className="main-content-container px-4 pb-4 bg-white mt-2">
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />

            <Modal size="md" fade={false} style={{ width: '500px' }} backdrop={false} className="d-flex align-items-center justify-content-center w-auto h-100" open={openModal} toggle={toggle}>
                <div className="d-flex justify-content-end p-1 mx-2"><i class="fa-solid fa-xmark primary-text bg-white" role="button" onClick={toggle}></i></div>
                <ModalBody className={!bulkUpdate ? "px-5" : 'px-0'}>
                    <div>
                        <Form onSubmit={onSubmit}>
                            {formData.bulkAction === CHANGE_STATUS ? !bulkUpdate ? <Row className="w-100">
                                <Col lg="6" className="my-auto pb-4">
                                    <label className="h4 font-weight-bold my-auto">Set Status:</label>
                                </Col>
                                <Col lg="6" className="px-0 pb-4">
                                    <FormSelect name='status'
                                        value={formData.status}
                                        onChange={onChange}
                                    >
                                        <option value=''>Select Status</option>
                                        { generalStatusGroup }
                                        { invoicePayableStatusGroup }

                                        { payableStatusGroup }
                                        { paymentStatusGroup }
                                    </FormSelect>
                                </Col>
                                <Col lg="6"></Col>
                                <Col lg="6" className="d-flex flex-row justify-content-between px-0">
                                    <Button name="set" className="px-4">Set</Button>
                                    <Button name="cancel" onClick={toggle} className="px-4">Cancel</Button>
                                </Col>

                            </Row> :
                                <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                    <Col lg="12" className="my-auto pb-4 tex-center pl-2 px-0">
                                        <label className="font-weight-bold my-auto">The status has been changed to <span><label className="primary-text">{formData.status}</label></span> for the selected items</label>
                                    </Col>
                                    <Col lg="12" className="d-flex flex-row justify-content-center">
                                        <div className="d-flex flex-row justify-content-between">
                                            <Button name="cancel" onClick={toggle} className="px-4 mx-2">Close</Button>
                                        </div>
                                    </Col>

                                </Row>
                                : !bulkUpdate ?
                                    <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                        <Col lg="12" className="my-auto pb-4 tex-center">
                                            <label className="font-weight-bold my-auto">Are you sure you want to send all  <span><span>{`{`}</span><label className="primary-text">{`1`}</label><span>{`}`}</span></span> invoices?</label>
                                        </Col>
                                        <Col lg="12" className="d-flex flex-row justify-content-center">
                                            <div className="d-flex flex-row justify-content-between">
                                                <Button name="yes" className="px-4 mx-2">Yes</Button>
                                                <Button name="cancel" onClick={toggle} className="px-4 mx-2">Cancel</Button>
                                            </div>
                                        </Col>

                                    </Row>
                                    :
                                    <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                        <Col lg="12" className="my-auto pb-4 text-center pl-3">
                                            <label className="font-weight-bold my-auto">This feature is currently not available.</label>
                                        </Col>
                                        <Col lg="12" className="d-flex flex-row justify-content-center">
                                            <div className="d-flex flex-row justify-content-between">
                                                <Button name="cancel" onClick={toggle} className="px-4 mx-2">Close</Button>
                                            </div>
                                        </Col>

                                    </Row>
                            }
                        </Form>
                    </div>
                </ModalBody>
            </Modal>
            <Card>
                <CardHeader className="px-4">
                    <div className="page-header tableSearch client_invoice flex-column flex-md-row py-2 d-flex btn-accent mt-2">

                        <div className="d-flex align-items-center ml-2 mt-1 mb-1 p-1 bg-white"></div>

                        <div className="d-flex align-items-center p-2 ml-1 custom_maxwidth_9 justify-content-center">
                            <div className="d-flex align-items-center p-2 invRefBox">
                                {'RST-' + formData.refNum}
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 custom_maxwidth_30">
                            <div>
                                <label><i>Process:</i> </label>
                            </div>
                            <div className=''>
                                <span>{formData.process}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 custom_maxwidth_12">
                            <div>
                                <label><i>Invoice Date:</i> </label>
                            </div>
                            <div className=''>
                                <span>{setDateForTable(formData.invoiceDate)}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 custom_maxwidth_12">
                            <div>
                                <label><i>Due Date:</i> </label>
                            </div>
                            <div className=''>
                                <span>{setDateForTable(formData.invoiceDate)}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 custom_maxwidth_25">
                            <div>
                                <label><i>{ formData.resultStatus } By:</i> </label>
                            </div>
                            <div className=''>
                                <span>{formData.actionedBy}</span>
                            </div> 
                        </div>

                        <div className="form-group p-2 mb-0 custom_maxwidth_12">
                            <div>
                                <label><i>{ formData.resultStatus } On:</i> </label>
                            </div>
                            <div className=''>
                                <span>{setDateForTable(formData.dateActioned)}</span>
                            </div>
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="paddingtopzero w-100">
                    <Row className="px-2">
                        <Col lg="6" className="">
                            <Row>
                                <Col lg="12" className="form-group m-0 p-2">
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Invoiced Amount:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            {/* currency requires to add */}
                                            <label className="">{formatNumberAmount(formData.totalInvoiceAmount, 'en-US', 2, 2)} {formData.currency} </label>
                                        </Col>

                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Payable Amount:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className="">{formatNumberAmount(formData.totalPayableAmount, 'en-US', 2, 2)} {formData.currency}</label>
                                        </Col>
                                    </Row>
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Payments (in):</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className="">{formatNumberAmount(formData.totalPaymentIn, 'en-US', 2, 2)} {formData.currency}</label>
                                        </Col>

                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Payments (out):</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className="">{formatNumberAmount(formData.totalPaymentOut, 'en-US', 2, 2)} {formData.currency}</label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <div className="d-flex align-items-center p-2">
                                <Button className="mx-2 py-2 my-2 btn btn-accent btn-sm" onClick={resetProcessFlag}> Cancel Records and Reset Processed Flag </Button>
                            </div>
                        </Col>
                        <Col lg="4" className=''>
                            <div className='custom-header justify-content-center border'>
                                <ReactTable
                                    columns={tablePayScheduleColumns}
                                    data={tablePayScheduleData}
                                    pageSize={Number(tablePayScheduleData.length)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    pagination={false}
                                    showPaginationBottom={false}
                                    className="w-100 h-90 automationResult_overflowAuto"
                                    noDataText=" "
                                />
                            </div>
                        </Col>
                        <Col lg="2" className='p-0'>
                            <div className='custom-header justify-content-center border'>
                                <ReactTable
                                    columns={tableCurrencyColumns}
                                    data={tableCurrencyData}
                                    pageSize={Number(tableCurrencyData.length)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    pagination={false}
                                    showPaginationBottom={false}
                                    className="w-100 h-90 automationResult_overflowAuto"
                                    noDataText=" "
                                />
                            </div>
                        </Col>
                    </Row>
                    <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                        <div className="d-flex align-items-center p-2">
                            <FormInput
                                name='autoRefNum' value={formData.autoRefNum}
                                onChange={onChange} placeholder="Ref #"
                            />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <FormInput
                                name='description' value={formData.description}
                                onChange={onChange} placeholder="Description"
                            />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <Multiselect
                                hideSelectedList
                                displayValue="key"
                                placeholder={`Type: ${(selectedTypeValues && selectedTypeValues.length > 0 && selectedTypeValues[0].key === ALL) ? ALL : selectedTypeValues.map(val => val.key).toString()}`}
                                onKeyPressFn={function noRefCheck() { }}
                                onSearch={function noRefCheck() { }}
                                onRemove={function noRefCheck(selectedOptions, item) {
                                    if (item.key === ALL) {
                                        setSelectedTypeValues([])
                                    } else {
                                        selectedOptions = selectedOptions.filter(option => option.key !== ALL)
                                        setSelectedTypeValues([...selectedOptions])
                                    }
                                }}
                                onSelect={function noRefCheck(selectedOptions, seletedItem) {
                                    if (seletedItem.key === ALL) {
                                        setSelectedTypeValues([...typeDropdownOptions])
                                    } else {
                                        if (selectedOptions.length === typeDropdownOptions.length - 1) {
                                            selectedOptions = [...typeDropdownOptions]
                                        }
                                        setSelectedTypeValues([...selectedOptions])
                                    }
                                }}
                                options={[
                                    ...typeDropdownOptions
                                ]}
                                selectedValues={[...selectedTypeValues]}

                                showCheckbox />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <Multiselect
                                hideSelectedList
                                displayValue="key"
                                placeholder={`Pay Period: ${(selectedPayPeriodValues && selectedPayPeriodValues.length > 0 && selectedPayPeriodValues[0].key === ALL) ? ALL : selectedPayPeriodValues.map(val => val.key).toString()}`}
                                onKeyPressFn={function noRefCheck() { }}
                                onSearch={function noRefCheck() { }}
                                onRemove={function noRefCheck(selectedOptions, item) {
                                    if (item.key === ALL) {
                                        setSelectedPayPeriodValues([])
                                    } else {
                                        selectedOptions = selectedOptions.filter(option => option.key !== ALL)
                                        setSelectedPayPeriodValues([...selectedOptions])
                                    }
                                }}
                                onSelect={function noRefCheck(selectedOptions, seletedItem) {
                                    if (seletedItem.key === ALL) {
                                        setSelectedPayPeriodValues([...payPeriodDropdownOptions])
                                    } else {
                                        if (selectedOptions.length === payPeriodDropdownOptions.length - 1) {
                                            selectedOptions = [...payPeriodDropdownOptions]
                                        }
                                        setSelectedPayPeriodValues([...selectedOptions])
                                    }
                                }}
                                options={[
                                    ...payPeriodDropdownOptions
                                ]}
                                selectedValues={[...selectedPayPeriodValues]}

                                showCheckbox />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <Multiselect
                                hideSelectedList
                                displayValue="key"
                                placeholder={`Status: ${(selectedStatusValues && selectedStatusValues.length > 0 && selectedStatusValues[0].key === STATUS_ALL) ? STATUS_ALL : selectedStatusValues.map(val => val.key).toString()}`}
                                onKeyPressFn={function noRefCheck() { }}
                                onSearch={function noRefCheck() { }}
                                onRemove={function noRefCheck(selectedOptions, item) {
                                    if (item.key === STATUS_ALL) {
                                        setSelectedStatusValues([])
                                    } else {
                                        selectedOptions = selectedOptions.filter(option => option.key !== STATUS_ALL)
                                        setSelectedStatusValues([...selectedOptions])
                                    }
                                }}
                                onSelect={function noRefCheck(selectedOptions, seletedItem) {
                                    if (seletedItem.key === STATUS_ALL) {
                                        setSelectedStatusValues([...statusDropdownOptions])
                                    } else {
                                        if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                            selectedOptions = [...statusDropdownOptions]
                                        }
                                        setSelectedStatusValues([...selectedOptions])
                                    }

                                }}
                                options={[
                                    ...statusDropdownOptions
                                ]}
                                selectedValues={[...selectedStatusValues]}

                                showCheckbox />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <Multiselect
                                hideSelectedList
                                displayValue="key"
                                placeholder={`Currency: ${(selectedCurrencyValues && selectedCurrencyValues.length > 0 && selectedCurrencyValues[0].key === ALL) ? ALL : selectedCurrencyValues.map(val => val.key).toString()}`}
                                onKeyPressFn={function noRefCheck() { }}
                                onSearch={function noRefCheck() { }}
                                onRemove={function noRefCheck(selectedOptions, item) {
                                    if (item.key === ALL) {
                                        setSelectedCurrencyValues([])
                                    } else {
                                        selectedOptions = selectedOptions.filter(option => option.key !== ALL)
                                        setSelectedCurrencyValues([...selectedOptions])
                                    }
                                }}
                                onSelect={function noRefCheck(selectedOptions, seletedItem) {
                                    if (seletedItem.key === ALL) {
                                        setSelectedCurrencyValues([...currencyDropdownOptions])
                                    } else {
                                        if (selectedOptions.length === currencyDropdownOptions.length - 1) {
                                            selectedOptions = [...currencyDropdownOptions]
                                        }
                                        setSelectedCurrencyValues([...selectedOptions])
                                    }

                                }}
                                options={[
                                    ...currencyDropdownOptions
                                ]}
                                selectedValues={[...selectedCurrencyValues]}

                                showCheckbox />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <div className="d-flex align-items-center p-2">
                                <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                                    <DatePicker
                                        name="from"
                                        size="sm"
                                        selected={formData.from}
                                        onChange={(date) => {
                                            setFormData({ ...formData, from: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="From"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                    />
                                    <DatePicker
                                        name="to"
                                        size="sm"
                                        selected={formData.to}
                                        onChange={(date) => {
                                            setFormData({ ...formData, to: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="To"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                        popperPlacement="top-end"
                                    />
                                    <InputGroupAddon type="append">
                                        <InputGroupText>
                                            <i className="material-icons">&#xE916;</i>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end p-2">
                            <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                                onClick={onSearch}>Search</Button>
                            <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                                Reset
                            </Button>
                        </div>
                    </div>
                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    {/* Filters :: Page Size */}

                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                        <span>
                                            <FormSelect size="sm" name='bulkAction' className="w-100"
                                                value={formData.bulkAction} onChange={onChange}
                                            >
                                                <option key="bulkActions0" value="">Bulk Actions</option>
                                                <option key="download2" value={DOWNLOAD}>Download</option>
                                                <option key="changeStatus1" value={CHANGE_STATUS}>Change Status</option>
                                            </FormSelect>
                                        </span>
                                    </Col>
                                    <Col lg="3" className="d-flex align-items-center">
                                    </Col>
                                    <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                    </Col>

                                    <Col lg="1"
                                        className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                        <span>Show</span>
                                        <FormSelect
                                            size="sm"
                                            name='pageSize'
                                            value={formData.pageSize}
                                            onChange={onChange}
                                        >
                                            {formData.pageSizeOptions.map((size, idx) => (
                                                <option key={idx} value={size}>
                                                    {size} rows
                                                </option>
                                            ))}
                                        </FormSelect>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="">
                                <ReactTable
                                    columns={tableColumns}
                                    data={tableItemData}
                                    pageSize={Number(formData.pageSize)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    noDataText="No results found"
                                    previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                                    nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    currencyList: state.invoice.currencyList,
    automationResultData: state.automation.automationResultData,
    automationActions: state.automation.automationActions,
});
export default connect(mapStateToProps, {
    get_currency_list,
    get_automation_process_details,
    reset_automation_detail,
    reset_process_flag,
    get_automation_bulk_action_list,
    download_automation_results,
    bulk_update_automation_status,
})(AutomationResultDetail);
